const Mn = require('backbone.marionette');
const GoogleAccount = require('jiji/domain/entity/account/google');
const QuadceptAccount = require('jiji/domain/entity/account/quadcept');
const GoogleAccountView = require('jiji/ui/view/account/google');
const QuadceptAccountView = require('jiji/ui/view/account/quadcept');

module.exports = Mn.CollectionView.extend({
    tagName: 'ul',
    className: 'collection',
    childView: function(item) {
        if(item instanceof GoogleAccount) {
            return GoogleAccountView
        }
        if(item instanceof QuadceptAccount) {
            return QuadceptAccountView
        }
    }
});




// WEBPACK FOOTER //
// ./jiji/ui/view/account/list.js